/* eslint-disable import/prefer-default-export */
import HTTP from '../HTTP';

const URL_BASE = 'commun/SignatureElectroniqueInitiliase/';

export async function initialiseCallBack(societeId) {
  const response = await HTTP.post(URL_BASE + 'InitialiseCallBackAsync', { id: societeId });
  return response;
}
